import * as _ from 'underscore';
import React from 'react';

import { blockCategories } from '../../../../lib/paramTypes';

import Console from '../../../../lib/debug';

export default class MDSearch extends React.Component {
    state = {
        value: ''
    };

    componentDidMount() {
        let inputValue = null;
        if (this.props.isEmptyCircuit) {
            inputValue = this.props.value.title;
        } else {
            inputValue = this.props.search;
        }
        this.state.value = inputValue;
    }
    componentWillReceiveProps(nextProps) {
        // Clear the search field when the megadrop is opened
        let value = this.state.value;
        let categoryValue = _.find(
            blockCategories,
            cat => cat.title.toLowerCase() === value.toLowerCase()
        );
        if (this.props.type === 'circuit') {
            /* Drop down is opening */
            if (nextProps.isMDOpen && !this.props.isMDOpen) {
                value = '';
            } else if (nextProps.isMDOpen && this.props.isMDOpen) {
                /* Drop down is open and focus on search */
                value = nextProps.search;
            } else if (
                /* Drop down is closing and there is a categoryValue */
                !nextProps.isMDOpen &&
                !this.props.isMDOpen &&
                categoryValue
            ) {
                value = nextProps.value.title;
            } else {
                if (nextProps.value.workout_combo_id) {
                    value = '';
                } else {
                    value = nextProps.value.title;
                }
            }
            this.setState(() => ({
                value
            }));
        } else {
            if (nextProps.isMDOpen && this.props.isMDOpen) {
                value = nextProps.search;
            } else if (!nextProps.isMDOpen && this.props.isMDOpen) {
                value = '';
            }
            this.setState(() => ({
                value
            }));
        }
    }
    onKeyUp = e => {
        let isMDOpen = this.props.isMDOpen;
        if (isMDOpen && e.key === 'Escape') {
            this.onValueBlur(e);
        }
        this.props.onKeyUp(e);
    };
    onValueBlur = e => {
        return this.props.onBlur && this.props.onBlur(e.target.value);
    };
    onValueChange = e => {
        let value = e.target.value;
        if (this.props.isMDOpen) {
            this.props.onChange(value);
        }
        this.setState(() => ({
            value: value
        }));
    };
    render() {
        Console.render('designer.MegaDropSearch');
        const className =
            'MegaDrop-input MegaDrop-value MegaDrop-item-selected';
        let input = (
            <div className={className}>
                <input
                    type="text"
                    ref={this.props.inputRef}
                    placeholder=""
                    onKeyUp={this.onKeyUp}
                    value={this.state.value}
                    onChange={this.onValueChange}
                    onBlur={this.onValueBlur}
                />
            </div>
        );
        return input;
    }
}
